export const downloadCSVBlob = (data, fileName) => {
  const csvBlob = data instanceof Blob
    ? data
    : new Blob([data], { type: "text/csv;charset=utf-8" });
  const downloadUrl = URL.createObjectURL(csvBlob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
};
